import { Reveal, Eyebrow } from "./Reveal";

const CHAPTERS = [
  {
    n: "01",
    title: "We design the experience",
    body: "We create warm, thoughtfully organized gatherings that encourage connection, celebration, and family engagement.",
  },
  {
    n: "02",
    title: "Your community comes together",
    body: "Residents, families, and staff share something joyful in a welcoming, unhurried setting.",
  },
  {
    n: "03",
    title: "Photography preserves it",
    body: "Professional photography naturally documents the relationships and meaningful moments created during the experience.",
  },
];

export default function WhatWeDo() {
  return (
    <section id="what-we-do" className="py-24 md:py-32 lg:py-40">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-4">
            <Reveal>
              <Eyebrow>What We Do</Eyebrow>
              <h2 className="mt-5 font-poppins font-bold text-charcoal text-4xl md:text-5xl leading-tight tracking-tight">
                Community is the experience.
              </h2>
              <p className="mt-6 text-lg leading-relaxed text-charcoal/70">
                Photography documents the moments — but connection is the heart of everything we create.
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-8 lg:pt-2">
            <div className="space-y-3">
              {CHAPTERS.map((c, i) => (
                <Reveal key={c.n} delay={i * 0.1}>
                  <div className="group flex flex-col md:flex-row gap-5 md:gap-10 rounded-[2rem] bg-white p-8 md:p-10 border border-border transition-all hover:-translate-y-1 hover:shadow-[0_30px_60px_-30px_rgba(240,125,106,0.25)]">
                    <span className="font-poppins font-extrabold text-5xl md:text-6xl text-coral/25 leading-none group-hover:text-coral/60 transition-colors">
                      {c.n}
                    </span>
                    <div>
                      <h3 className="font-poppins font-bold text-2xl md:text-3xl text-charcoal">{c.title}</h3>
                      <p className="mt-3 text-lg leading-relaxed text-charcoal/70 max-w-2xl">{c.body}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
